import { CustomerComponent } from './customer.component';
import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatePipe } from "@angular/common";


import { AuthorizationModule } from '../../modules/authorization/authorization.module';
import { AddOrEditCustomerComponent } from './components/add-or-edit-customer/add-or-edit-customer.component';
import { AddCustomerAdminComponent } from './components/add-customer-admin/add-customer-admin.component';
import { AssignResourcesComponent } from './components/assign-resources/assign-resources.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { TableModule } from '../../lib';
import { SharedModule } from '../../modules/shared/shared.module';
import { MaterialModule } from '../../modules/material/material.module';
import {NgxMatIntlTelInputComponent} from 'ngx-mat-intl-tel-input';
import { CapitalizeFirstPipe } from '../capitalize-first.pipe';


const routes: Routes = [
  { path: '', pathMatch: "full", component: CustomerComponent },
  { path: 'addCustomer', pathMatch: "full", component: AddOrEditCustomerComponent },
]
@NgModule({
  declarations: [
    CustomerComponent,
    AddOrEditCustomerComponent,
    AddCustomerAdminComponent,
    AssignResourcesComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    TableModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule,
    AuthorizationModule,
    RouterModule.forChild(routes),
    MaterialModule,
    NgxMatIntlTelInputComponent,
    CapitalizeFirstPipe
  ],
  providers: [
    DatePipe,
  ],
  schemas : [CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA]
})
export class CustomerModule { }
